import { useSelector } from 'react-redux';
import { useEffect, useState, useMemo } from 'react';
export const useAppSelector = useSelector;
export const useAfterPaintEffect = (effect, dependencies) => {
    useEffect(() => {
        requestAnimationFrame(() => {
            setTimeout(() => {
                effect();
            }, 0);
        });
    }, dependencies);
};
export function useInViewport(ref) {
    const [isIntersecting, setIntersecting] = useState(false);
    const observer = useMemo(() => new IntersectionObserver(([entry]) => setIntersecting(entry.intersectionRatio >= 0.3), {
        threshold: 0.3
    }), [ref]);
    useEffect(() => {
        if (ref?.current) {
            observer.observe(ref.current);
        }
        return () => observer.disconnect();
    }, []);
    return isIntersecting;
}
